export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img src="/logo-icon.png" alt="شعار دليل المسافر للحجوزات" className={`${className} rounded-[22%] shadow-lg shadow-black/10`} />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={compact ? "h-10 w-10" : "h-12 w-12"} />
    <span className="flex flex-col leading-tight">
      <span className="font-display font-bold text-base sm:text-lg text-[#1A1A1E]">دليل المسافر للحجوزات</span>
      <span className="text-[10px] tracking-[0.35em] text-brand font-semibold uppercase" dir="ltr">
        Travelers Guide
      </span>
    </span>
  </span>
);
